export const priceTypingProcess = (val, negativeAllowed)=>{    
    if(typeof(val) != "string")val=`${val}`;
    let numberIsNegative = parseFloat(val.replace(/(?!^-)[^0-9.,]/g, '')) < 0.0;
    val = val.replace(/[^0-9.,]/g,'');

    if(val === '')return'';
    let newVal = val.match(/^(?!,$)[\d,.]+$/)[0];
    if(newVal.charAt(0) !== '$'){
        newVal = '$'+newVal;
    }
    return (negativeAllowed && numberIsNegative ? '-':'')+newVal;
}
export const priceOnFinish = (val, noDecimal, negativeAllowed) => {
    if(typeof(val) != "string")val=`${val}`;
    let decimalPart = '.00';
    let numberIsNegative = parseFloat(val) < 0.0;
    if(val.includes(".") ){
        decimalPart = val.substr(val.lastIndexOf('.'), 3);
        if(decimalPart.length === 2){
            decimalPart += "0";
        }
        // const decimalPartLength = val.length - val.lastIndexOf('.');
        // if(decimalPartLength === 3){
            
        // }else if(decimalPartLength === 2){
            
        // }
        // // two decimals present
        
        val = val.substr(0, val.lastIndexOf('.'));
    }
    
    
    val = val.replace(/[^0-9]/g,'');
    
    let finalString = '';
    if(val.length < 4){
        finalString = `$${val}`
    }else{
        do{
            if(val.length < 4 || val.length === 0){
                // if(finalString.charAt(0)===',')finalString=finalString.substring(1);
                finalString = `$${val}${finalString}`
                break;
            }
            finalString = ',' + val.substring(val.length-3) + finalString;
            
            val = val.substring(0, val.length-3)
        }while(true)
    }

    return `${negativeAllowed && numberIsNegative ? '-' : ''}${finalString}${noDecimal?'':decimalPart}`;
}
export const percentageTypingProcess = (val)=>{
    
    val = val.replace(/[^0-9.]/g,'');
    if(val === '')return'';
    let newVal = val.match(/^(?!,$)[\d,.]+$/)[0];
    if(newVal.charAt(newVal.length-1) !== '%'){
        newVal = newVal+'%';
    }
    return newVal;
}